export default "dist/images/components-columns-width-control-3-3-uneven.9e97ae9.png";